// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';

export const GET_SOLD_TO_SHIP_TO = 'GET_SOLD_TO_SHIP_TO';
export const GET_SOLD_TO_SHIP_TO_SUCCESS = 'GET_SOLD_TO_SHIP_TO_SUCCESS';

export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';

export const GET_CHANNELS = 'GET_CHANNELS';
export const GET_CHANNELS_SUCCESS = 'GET_CHANNELS_SUCCESS';

export const GET_TIERS = 'GET_TIERS';
export const GET_TIERS_SUCCESS = 'GET_TIERS_SUCCESS';
export const CLEAR_TIERS = 'CLEAR_TIERS';

export const POST_USER = 'POST_USER';
export const POST_USER_SUCCESS = 'POST_USER_SUCCESS';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

export const CLEAR_USER_MESSAGE = 'CLEAR_USER_MESSAGE';

export const {
    getAllUsers,
    getAllUsersSuccess,

    getSoldToShipTo,
    getSoldToShipToSuccess,

    getRoles,
    getRolesSuccess,

    getChannels,
    getChannelsSuccess,

    getTiers,
    getTiersSuccess,
    clearTiers,

    postUser,
    postUserSuccess,

    deleteUser,
    deleteUserSuccess,

    clearUserMessage,
} = createActions(
    GET_ALL_USERS,
    GET_ALL_USERS_SUCCESS,

    GET_SOLD_TO_SHIP_TO,
    GET_SOLD_TO_SHIP_TO_SUCCESS,

    GET_ROLES,
    GET_ROLES_SUCCESS,

    GET_CHANNELS,
    GET_CHANNELS_SUCCESS,

    GET_TIERS,
    GET_TIERS_SUCCESS,
    CLEAR_TIERS,

    POST_USER,
    POST_USER_SUCCESS,

    DELETE_USER,
    DELETE_USER_SUCCESS,

    CLEAR_USER_MESSAGE
);
